import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Notification {
  title: string;
  type?: "urgent" | "warning" | "info" | "read";
  timestamp: string;
  details?: string;
  read?: boolean;
  alertRecipientId?: number;
}

interface AlertState {
  unreadCount: number;
  notifications: Notification[];
}

// Initial state
const alertState: AlertState = {
  unreadCount: 0,
  notifications: [],
};

const alertReducers = {
  setUnreadCount(state: AlertState, action: PayloadAction<number>) {
    state.unreadCount = action.payload;
  },
  setNotifications(state: AlertState, action: PayloadAction<Notification[]>) {
    state.notifications = action.payload;
  },
};

// Slice creation
const alertSlice = createSlice({
  name: "alerts",
  initialState: alertState,
  reducers: alertReducers,
});

export const { setUnreadCount, setNotifications } = alertSlice.actions;
export const alertActions = alertSlice.actions;
export default alertSlice;
